import Cookies from 'js-cookie';
import { throwIfFailedRead } from '~/lib/apiErrors';

/**
 * The SWR fetcher both root shells share (components/RootShell): the app's and a club
 * website's. Moved out of the root layout unchanged when that layout split in two, so
 * the two cannot drift in how they call the API.
 */
export const swrFetcher = (key: string | [string, object], init: RequestInit, throwErrors = false) => {
    let resource = key as string,
        params = {};
    // Array.isArray, not lodash's: this module is on every club website, and lodash's
    // `isArray` import pulled the whole library in with it.
    if (Array.isArray(key)) {
        resource = key?.[0];
        params = key?.[1];
    }

    const url = new URL(
        resource.startsWith('http') || resource.startsWith('api/')
            ? resource
            : process.env.NEXT_PUBLIC_API_HOST + resource
    );

    const stringify = (value: any) => {
        switch (typeof value) {
            case 'object':
                return JSON.stringify(value);
            default:
                return String(value);
        }
    };

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((v, i) => url.searchParams.append(`${key}[${i}]`, stringify(v)));
        } else url.searchParams.append(key, stringify(value));
    });

    return fetch(url.toString(), {
        headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
            ['Content-Type']: 'application/json',
            ['X-Requested-With']: 'XMLHttpRequest',
            ['Content-Language']: 'de'
        },
        ...init
    }).then(async (res) => {
        if (res.status === 503) {
            window.location.href = '/maintenance';
            return { data: [] };
        }

        // 423 = club locked over open chargebacks — same rule as the pages router's fetcher
        if (res.status === 423) {
            if (!window.location.pathname.startsWith('/gesperrt')) window.location.href = '/gesperrt';
            return { data: [] };
        }

        const data = await res.json();
        if (throwErrors && res.status === 500) throw new Error(data);

        // Same rule as the pages router's fetcher, from the same place: a screen
        // must not behave differently depending on which router rendered it.
        throwIfFailedRead(res, data);

        return data;
    });
};
